import React, { useEffect, useState } from 'react'
import { config } from '../../CommonUtilities/CommonUrl/CommonUrls'
import { CommonAxiosGet } from '../../CommonUtilities/CommonAxios/CommonAxios'
import { CommonPageHeading } from '../../CommonUtilities/CommonHeading/CommonPageHeading'
import { CommonReactTable } from '../../CommonUtilities/CommonTable/CommonReactTable'

export default function SchoolVacancyReport() {

        const [vacancy, setVacancy] = useState(false)
          const [vacancyLevel, setVacancyLevel] = useState(0)
        function getVacancyData() {
            let Url = config.url.DSC_URL + "getVcancySchoolsForCandidates"
            CommonAxiosGet(Url).then((res) => {
                if (res?.data?.status === true) {
                        setVacancy(res?.data?.data)
                        setVacancyLevel(1)
                        
                   
                }
            })
        }
 useEffect(() => { getVacancyData() }, [])
const management = vacancy?.[0]?.management ;
 const postName = vacancy?.[0]?.post_name;
 const distZone = vacancy?.[0]?.dist_name;
  const vacancycolumns = [
    { Header: "S.NO", accessor: (row, index) => index + 1, Footer: 'Total' },
   { Header: "District Name", accessor: "dist_name" },
    { Header: "Mandal Name", accessor: "block_name" },
    { Header: "School Code", accessor: "school_code" },
    { Header: "School Name", accessor: "school_name" },
    
    // { Header: "Block Name", accessor: "block_name" },
   {
  Header: () => (
<div style={{ fontSize: '12px', fontWeight: 'bold', whiteSpace: 'normal', textAlign: 'center' }}>
Distance from <br /> Mandal HeadQuarters </div> ),
accessor: "route_distance",
  Cell: ({ value }) => (
    <span style={{ fontSize: '12px' }}> {value} </span> )},
    { Header: "Clear Vacancies", accessor: "clear_vacancies" },
    { Header: "Cluster Vacancies", accessor: "cluster_vacancies" },
    { Header: "Total Vacancies", accessor: "total_vacancies" },]
  return (
    <div> <CommonPageHeading heading="School Wise Vacancy Report" back={false} /> 
      {vacancy?.length > 0 ? (
        <div className="table-responsive">
          <CommonReactTable 
            tableid='selected-id' pagination='false' data={vacancy} 
            columns={vacancycolumns} serachAlign="left" paginationCount="All"
            isBack={false} headerName={( <>
    School Wise Vacancy Report -{' '}
    <span style={{ color: '#007BFF', fontWeight: 'bold' }}>{management}</span>{' '}-{' '}
    <span style={{ color: '#0c8a2aff', fontWeight: 'bold' }}>{postName}</span> - <span style={{ color: '#f05a30ff', fontWeight: 'bold' }}>{distZone}</span>
  </>)} headColumCount={12} search="true" showFooter="true" filename="Report" />
        </div>) : (<div className="text-error text-center">*** No Data Found***</div>)}
    </div>
  )
}
